import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/largeLogo.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "agree_layer" }
const _hoisted_4 = { class: "agree_wrap" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "약관동의", -1)
const _hoisted_7 = { class: "agree_check" }
const _hoisted_8 = { class: "agree_content" }
const _hoisted_9 = { class: "agree_detail" }
const _hoisted_10 = { class: "detail_title" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "(필수)", -1)
const _hoisted_12 = { class: "detail_content" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "agree_detail" }
const _hoisted_15 = { class: "detail_title" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "(필수)", -1)
const _hoisted_17 = { class: "detail_content" }
const _hoisted_18 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", {
            class: _normalizeClass(["all_agree", $setup.checkbox.all ? 'active' : '']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onCheck(0)))
          }, [
            _createElementVNode("label", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(["checkbox", $setup.checkbox.all ? 'active' : ''])
              }, null, 2),
              _createTextVNode(" 전체동의 ")
            ])
          ], 2),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", {
                  class: "agree_check",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onCheck(1)))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["checkbox", $setup.checkbox[1] ? 'active' : ''])
                  }, null, 2),
                  _createElementVNode("p", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass($setup.checkbox[1] ? 'bold' : '')
                    }, [
                      _createTextVNode(" 이용약관 "),
                      _hoisted_11
                    ], 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", {
                  disabled: "",
                  innerHTML: $setup.terms.use,
                  class: "terms"
                }, null, 8, _hoisted_13)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", {
                  class: "agree_check",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onCheck(2)))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["checkbox", $setup.checkbox[2] ? 'active' : ''])
                  }, null, 2),
                  _createElementVNode("p", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass($setup.checkbox[2] ? 'bold' : '')
                    }, [
                      _createTextVNode(" 개인정보처리방침 "),
                      _hoisted_16
                    ], 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  disabled: "",
                  innerHTML: $setup.terms.privacy,
                  class: "terms"
                }, null, 8, _hoisted_18)
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["agree_btn", $setup.checkbox.all ? '' : 'off']),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.onAccept && $setup.onAccept(...args)))
          }, "승인요청", 2)
        ])
      ])
    ])
  ]))
}